export default {
    data() {
        return {
            showProgressCells: 'weight'
        }
    },
    mounted() {
        Vuemit.listen('PatientsMatrix--fetched', () => {
            this.$nextTick(() => {
                this.selectProgressCells(this.showProgressCells)
            })
        })
    },
    methods: {
        selectProgressCells(type) {
            this.showProgressCells = type

            Vuemit.fire('Cells--select', type)
        }
    }
}
